module.exports = __webpack_public_path__ + "static/media/aboutimg1.e913babe.webp";